import React, { useEffect, useRef, useState } from 'react';

const BackgroundAudio: React.FC = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const tryPlay = () => {
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => console.log('Background audio playing'))
          .catch(err => console.error('Audio play prevented:', err));
      }
    };
    tryPlay();
    document.addEventListener('click', tryPlay, { once: true });
    return () => {
      document.removeEventListener('click', tryPlay);
    };
  }, []);

  const toggleMute = () => {
    const audio = audioRef.current;
    if (audio) {
      const isCurrentlyMuted = audio.muted;
      audio.muted = !isCurrentlyMuted;
      setIsMuted(!isCurrentlyMuted);
      // If unmuting, trigger playback under user interaction
      if (isCurrentlyMuted) {
        const playPromise = audio.play();
        if (playPromise) {
          playPromise.catch(err => console.error('Manual audio play error:', err));
        }
      }
    }
  };

  return (
    <>
      {/* <button
        onClick={toggleMute}
        className="fixed bottom-4 right-4 p-2 bg-gray-800 text-white rounded"
      >
        {isMuted ? 'Unmute Music' : 'Mute Music'}
      </button> */}
      {/* <audio
        ref={audioRef}
        src="/images/background.mp3"
        loop
        autoPlay
        playsInline
        preload="auto"
        muted={isMuted}
        onPlay={() => console.log('Background audio started')}
        onError={(e) => console.error('Audio failed to play', e)}
      /> */}
    </>
  );
};

export default BackgroundAudio;
